import React, { useState, useEffect } from "react"
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import '../complaintRegistration/ComplaintRegistration.css';
import Header from "../header/Header";
import Menu from "../menu/Menu";
import red_line from '../../img/red_line.png';
import Modal from "../common/modal/Modal";
import plus from '../../img/plus.png';
import { MobileMenu } from "../mobileMenu/MobileMenu";
import SelectProductModal from "../selectProductModal/SelectProductModal";
import { clearAllPositions,  updateDetails } from "../../features/complaintPosition/ComplaintPositionSlice";
import '../common/customFileInput/FileInput.scss'
import { addComplaintPosition, deleteComplaintPosition, updateComplaintPosition } from "../../features/complaintPositions/ComplaintPositionsSlice";
import {ReactComponent as Edit} from '../../img/Edit.svg';
import {ReactComponent as Delete} from '../../img/Delete.svg';
import moment from "moment";
import { setShippingMethod } from "../../features/complaintPosition/ComplaintPositionSlice";
import '../../styles/styles.css';
import { setTextForSearching } from "../../features/products/productSlice";
import { getQuantityCorrectionsProposals } from "../../features/quantityCorrectionsProposals/QuantityCorrectionsProposalsSlice";
import { getCouriers } from "../../features/couriers/couriersSlice";
import { getShippingMethods } from "../../features/shippingMethod/shippingMethodSlice";
import { ComplaintTypesForms } from "../common/complaintTypesForms/ComplaintTypesForms";
import { IS_INTERNAL_APP } from "../../api/ApiSettings";
import { clearFiles } from "../../features/files/FileSlice";
import { SaveCancelButtons } from "../common/buttons/saveCancelButtons/SaveCancelButtons";
import { NextAndBackButtons } from "../common/buttons/nextAndBackButtons/NextAndBackButtons";

const ComplaintRegistration = () => {
const dispatch = useDispatch();
const navigate = useNavigate();
const [selectedOption, setSelectedOption] = useState('');    
const [isOpen, setIsOpen] = useState(false);
const [isMobile, setIsMobile] = useState(window.matchMedia("(max-width: 600px)").matches);   
const [isMenuOpen, setIsMenuOpen] = useState(false);
const [currentPage, setCurrentPage] = useState(window.location.pathname);
const [formSubmitted, setFormSubmitted] = useState(sessionStorage.getItem('formSubmitted') === 'true');
const [isDelete, setIsDelete] = useState(false);
const details = useSelector((state)=>state.complaintPosition);
const complaintType = useSelector((state) => state.complaint.complaintType.id);
const complaintTitle = useSelector((state)=>state.complaint.complaintType.displayName);
const complaintTypeName = useSelector((state)=>state.complaint.complaintType.name);
const shipping = useSelector((state)=>state.shipping.shippingMethods);
const positions = useSelector((state) => state.complaintPositions.positions);
//pobieranie plików

const [formValues, setFormValues] = useState({...details, id:null});
const [positionIdToEdit, setPositionIdToEdit] = useState(null);
const [isDataValid, setIsDataValid] = useState(false);
const [clearText, setClearText] = useState(false);
const [isEditMode, setIsEditMode] = useState(false);
const [selectedProduct, setSelectedProduct] = useState(null);
const [formErrors, setFormErrors] = useState({});
const complaintPositions = useSelector((state) => state.complaintPositions.positions);
const matchingPosition = complaintPositions.find((position) => position.id === positionIdToEdit);
const filesToDisplay = matchingPosition ? matchingPosition.files : [];//COMPLAINT POSITIONS

useEffect(() => {
        sessionStorage.setItem('formSubmitted', formSubmitted ? 'true' : 'false');
    }, [formSubmitted]);

    useEffect(() => {
        dispatch(getQuantityCorrectionsProposals());
        dispatch(getCouriers());
        dispatch(getShippingMethods());
      }, []);
    
   const handleSelectedOption = (option) => {
        setSelectedOption(option);
    };
const validateDate = (date) =>{
    const currentDate = new Date();
    const enteredDate = new Date(date);

    if(enteredDate > currentDate){
        console.log('Data nie może być większa od daty dzisiejszej');
        setIsDataValid(true);
        dispatch(updateDetails({faultDate: ''}))
    } else{
        setIsDataValid(false);
    }
}
   const handleDetailsChange = (e) => {
    if (!e || !e.target) return;

    const { name, value } = e.target;
    const updatedFormValues = { ...formValues };

    if (name === "shippingMethod") {
        const selectedMethod = shipping.find(item => item.displayName === value) || {};
        updatedFormValues.shippingMethod = selectedMethod;
        dispatch(setShippingMethod(selectedMethod));
    } else {
        updatedFormValues[name] = value;
    }

    setFormValues(updatedFormValues);
    dispatch(updateDetails(updatedFormValues));

    const requiredFields = getRequiredFields(complaintTypeName);
    let errors = validateFields(updatedFormValues, requiredFields);
    errors = {
        ...errors,
        ...validateSpecificConditions(
        complaintTypeName,
        updatedFormValues,
        details,
        isEditMode,
        filesToDisplay
        ),
    };
    setFormErrors(errors);
    }; 

   
    const getRequiredFields = (complaintTypeName) => {
        const requiredFieldsMap = {
            'SalesWarranty': ["faultDescription", "faultDate", "faultDiscoveryCircumstances", "salesDocumentNumber", "shipmentDescription", "shippingMethod", "files"],
            'UnderWarrantyLaserDeviceCalibration': ["faultDescription", "faultDate", "faultDiscoveryCircumstances", "salesDocumentNumber", "shipmentDescription", "shippingMethod", "files"],
            'PayedRepair': ["faultDescription", "faultDiscoveryCircumstances", "shippingMethod", "files"],
            'PostWarrantyLaserDeviceCalibration': ["faultDescription", "shippingMethod", "shipmentDescription", "files"],
        };
    
        return requiredFieldsMap[complaintTypeName] || [];
    };
    
const validateFields = (formValues, requiredFields) => {
    const errors = {};
    requiredFields.forEach(field => {
        if (!formValues[field] && !IS_INTERNAL_APP) {
            errors[field] = "Pole nie może być puste!";
        }
    });
    return errors;
};

    const validateSpecificConditions = (complaintTypeName, formValues, details, isEditMode, filesToDisplay) => {
        const errors = {};
        const currentDate = new Date();
    
        if (['SalesWarranty', 'UnderWarrantyLaserDeviceCalibration'].includes(complaintTypeName)) {
            if ((!isEditMode && details.files.length === 0) || (isEditMode && filesToDisplay.length <= 0)) {
                errors.files = "Nie podpięto załączników!";
            }
        }
    
        if (['SalesWarranty', 'UnderWarrantyLaserDeviceCalibration'].includes(complaintTypeName)) {
            if (formValues.faultDate && new Date(formValues.faultDate) > currentDate) {
                errors.faultDate = "Wprowadzona data jest niepoprawna!";
            }
        }
    
        if (formValues.salesDocumentNumber < 0) {
            errors.salesDocumentNumber = "Pole nie może zawierać wartości mniejszej niż zero!";
        }
    
        if (['SalesWarranty', 'UnderWarrantyLaserDeviceCalibration', 'Warranty', 'TransportDamage', 'PostWarrantyLaserDeviceCalibration', 'PayedRepair'].includes(complaintTypeName)) {
            if (!formValues.shippingMethod || Object.keys(formValues.shippingMethod).length === 0) {
                errors.shippingMethod = "Brak określonego sposobu wysyłki produktu!";
            }
        }
    
        if (!details.product) {
            errors.product = "Proszę wybrać produkt!";
        }
    
        return errors;
    };
    
    const handleSubmit = (e) => {
        e.preventDefault();
    
        const requiredFields = getRequiredFields(complaintTypeName);
    
        let errors = validateFields(formValues, requiredFields);
        errors = { ...errors, ...validateSpecificConditions(complaintTypeName, formValues, details, isEditMode, filesToDisplay) };
    
        setFormErrors(errors);
    
        if (Object.keys(errors).length > 0 && !IS_INTERNAL_APP) {
            setFormSubmitted(false);
            return;
        }
     
        if (positionIdToEdit !== null) {
            const editedPosition = {
                ...formValues,
                id: positionIdToEdit,
                productDisplayName: formValues.product.name,
                quantityCorrectionsProposalDisplayName: formValues.quantityCorrectionsProposal.displayName,
                files: filesToDisplay
            };
            dispatch(updateComplaintPosition(editedPosition));
            setPositionIdToEdit(null);
        } else {
            const newPosition = {
                ...details,
                id: positions.length + 1,
                productDisplayName: details.product.name,
                quantityCorrectionsProposalDisplayName: details.quantityCorrectionsProposal.displayName,
            };
            dispatch(addComplaintPosition(newPosition));
        }
    
        setFormValues({ ...details, id: null });
        setFormSubmitted(true);
        setFormErrors({});
        setIsOpen(false);
    };

    useEffect(() => {
        const handleWindowResize = () => {
            setIsMobile(window.matchMedia("(max-width: 767px)").matches);
        };
        window.addEventListener("resize", handleWindowResize);
        return () => {
            window.removeEventListener("resize", handleWindowResize);
        };
    }, []);

    useEffect(() => {
        function handlePageChange() {
            setCurrentPage(window.location.pathname);
        }
        window.addEventListener("popstate", handlePageChange);
        return () => {  
            window.removeEventListener("popstate", handlePageChange);
        };
    }, [currentPage]);
    
    const handleDelete = (positionId) => {
        dispatch(deleteComplaintPosition(positionId));
        setIsDelete(true);
    };

    const handleEdit = (id, selectedProduct) => {
        const position = positions.find((position) => position.id === id);
        if (position) {
            setFormValues({ ...position });
            setPositionIdToEdit(id);
            setSelectedProduct(selectedProduct);
            setIsEditMode(true);
            setIsOpen(true);
        }
    };
    
    const handleNextClick = () => {
        const requiredFields = getRequiredFields(complaintTypeName);
        let errors = {};
    
        requiredFields.forEach(field => {
            if (!formValues[field] && !IS_INTERNAL_APP) {
                errors[field] = `Pole ${field} nie może być puste!`;
            }
        });
    
        if (Object.keys(errors).length > 0) {
            const missingFields = Object.keys(errors).join(', ');
            alert(`Proszę uzupełnić pola oznaczone gwiazdką!`);
            return;
        }
    
        const isComplaintTypeWithFilesRequired = ['SalesWarranty', 'UnderWarrantyLaserDeviceCalibration'].includes(complaintTypeName);
        
        if (isComplaintTypeWithFilesRequired) {
            const hasNewFiles = formValues.files && formValues.files.length > 0;
            const hasExistingFiles = isEditMode && filesToDisplay && filesToDisplay.length > 0;
        
            if (!IS_INTERNAL_APP && !hasNewFiles && !(isEditMode && hasExistingFiles)) {
                alert("Formularz musi zawierać pliki przed kontynuowaniem!");
                return;
            }
        }
    
        if (positions.length > 0) {
            setCurrentPage('summary');
            navigate('/summary');
        }
    };

    const handleBackClick = () =>{
        setCurrentPage('information');
        navigate('/information');
    }

    const handleAddPosition = () => {
        setIsDelete(false);
        const initialFormValues = {
            id: null,
            faultDescription: '',
            faultDate: moment(),
            faultDiscoveryCircumstances: '',
            salesDocumentNumber: '',
            shipmentDescription: '',
            notes: '',
            shippingMethod: {},
            customerRequest: '',
            shippedQuantity: null,
            salesDocumentPosition: '',
            dateOfReceiptOfGoods: moment(),
            files: [],
            damagePhotoFile: null
        };
        dispatch(clearAllPositions());
        dispatch(clearFiles())
        setFormValues(initialFormValues);
        setClearText(true);
        dispatch(setTextForSearching(''));
        setPositionIdToEdit(null);
        setIsEditMode(false);
        setIsOpen(true);
    };
    
    const cancelComplaintForm = () =>{
        setIsOpen(!isOpen)
    }
   
return (
    <div>
        <Header/>
        {isMobile ? <MobileMenu isOpen={isMenuOpen} onClick={() => setIsMenuOpen(!isMenuOpen)}/> : <Menu isOpen={isMenuOpen} onClick={() => setIsMenuOpen(!isMenuOpen)}/>}
        <div className="add-complaint-info-container">
            <div className="add-complaint-info-title-container">
                <img style={{marginLeft: "0px"}}  src={red_line} className='red-line'/>
                <h3 className="add-complaint-info-title-text">Zgłoszenie dla {complaintTitle}</h3>
            </div>
            <p className="add-complaint-info-text">
                Firma Pro Sp. z o.o. udziela 24-miesięcznej gwarancji tylko dla produktów z grupy Urządzeń<br/>
                laserowych i optycznych z wyłączeniem akcesoriów laserowych (tyczki, statywy, adaptery, łaty<br/>
                niwelacyjne), 10 letniej gwarancji na libelle dla produktów z grupy: Poziomnice, Łaty, Kątownice.<br/><br/>
                Reklamacje na pozostałe produkty należy składać bezpośrednio u sprzedawcy.
            </p>
            {positions.map((position, index) => {
                                return (
                                    <div key={index} className="added-position-container">
                                    <div className="added-position-product-container">
                                        <p className="added-position-product-name"><b>{position.product.name}</b></p>
                                        <p className="added-position-index-code">Indeks: {position.product.code}</p>
                                    </div>
                
                                        <Edit style={{marginRight:'10px', cursor:'pointer'}} className="edit-btn" onClick={()=>handleEdit(position.id, position.product)} type='button' />
                                        <Delete style={{cursor:'pointer'}} className="delete-btn" onClick={()=>handleDelete(position.id)} type="button"/>
                                   
                                    </div>
                                );
                                })}

            <button className="add-position-btn" onClick={handleAddPosition}><p className="add-position-btn-text"><img src={plus}/> Dodaj pozycję</p></button>

                 </div>
        
                    <Modal open={isOpen} onClose={() => setIsOpen(!isOpen)}>
                        <div className="registration-container">
                    <div className={complaintTypeName === 'PayedRepair' || complaintTypeName === 'PostWarrantyLaserDeviceCalibration' ? "modal-container-other" : "modal-container"}>
                        <div className="modal-title">
                        <img src={red_line} className='red-line' style={{marginLeft:'0px', top:'1%'}}/>
                        <p className="modal-title-text"> Zgłoszenie dla {complaintTitle}</p>
                        </div>
                            <form onSubmit={handleSubmit} id="cleanComplaint">
                                <div className="modal-text-field">
                                <div>
                                <label>Produkt</label>
                                <SelectProductModal
                                    setSelectedProduct={handleSelectedOption}
                                    complaintType={complaintType}
                                    selectedRow={selectedProduct}
                                    clearText={clearText}
                                    setClearText={setClearText}
                                    isEditMode={isEditMode}
                                    style={{border: formErrors.product ? "1px solid red" : "1px solid #ccc",fontFamily: 'Montserrat', fontWeight: '400', fontSize: '16px' }}
                                    />       
                                    {formErrors.product && <p className="error" style={{ marginTop: '0px' }}>{formErrors.product}</p>}<br/>
                           
                                    </div>
                                    {['SalesWarranty', 'PayedRepair','UnderWarrantyLaserDeviceCalibration','PostWarrantyLaserDeviceCalibration']
                                        .includes(complaintTypeName) && (
                                        <>
                                        <ComplaintTypesForms
                                            complaintTypeName={complaintTypeName}
                                            formValues={formValues}
                                            formErrors={formErrors}
                                            handleDetailsChange={handleDetailsChange}
                                            cancelComplaintForm={cancelComplaintForm}
                                            positionIdToEdit={positionIdToEdit}
                                            isDataValid={isDataValid}
                                        />
                                        <SaveCancelButtons onCancel={cancelComplaintForm} saveButtonType="submit" onSave={handleSubmit}/>    
                                        </>                            
                                    )} 
                                </div>
                               
                            </form>
                        </div>
                    </div>
                </Modal>
               <div className="next-back-buttons-container">
                    <NextAndBackButtons onBack={handleBackClick} onNext={handleNextClick}/>  
                </div>

           </div>
   )
}

export default ComplaintRegistration; 